
export const getVerificationSessionCookieName = (vendorName: string, azureUserId: string) => `${vendorName}_session_${azureUserId}`;
